export const arrayEquals = <T>(a: T[], b: T[]): boolean => {
    const setA = new Set(a.map(item => JSON.stringify(item)));
    const setB = new Set(b.map(item => JSON.stringify(item)));

    return setEquals(setA, setB);
}

export const setEquals = <T>(a: Set<T>, b: Set<T>): boolean => {
    if (a.size !== b.size) return false;

    for (const item of a) {
        if (!b.has(item)) {
            return false;
        }
    }
    return true;
}